(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wechat", [], factory);
	else if(typeof exports === 'object')
		exports["wechat"] = factory();
	else
		root["wechat"] = factory();
})(global, function() {
return 